import { LinearSRGBColorSpace, SRGBColorSpace } from "three";

export function applyModelVistaBaseColor(material, property) {
    if (!property) return;
    const value = property.VectorValue;
    // Unity shader Color properties are serialized in sRGB, including the
    // property named baseColorFactor. Standard glTF factors are already linear.
    const colorSpace = property.Type === "Color" ? SRGBColorSpace : LinearSRGBColorSpace;
    material.color.setRGB(
        Number(value?.X ?? 1), Number(value?.Y ?? 1), Number(value?.Z ?? 1), colorSpace
    );
    material.opacity = Number(value?.W ?? 1);
    material.transparent = material.opacity < 0.999;
}
